<template>
  <div class="card height-equal milestones-card">
    <div class="card-header">
      <h5 @click="changeTab('milestones')">Milestones</h5>
      <h5 @click="changeTab('calendar')" class="btn-calendar">Calendar</h5>

      <div class="d-flex">
        <button id="default-primary"  v-show="showMilestones" type="button" class="btn btn-pill btn-primary mr-2" @click="$refs['add-milestones'].show()">Create Milestones</button>
        <button class="btn btn-pill btn-primary mr-2" v-show="!showMilestones"  @click="reloadCalendar()">{{refreshBtn}}</button>
      </div>

      <b-modal ref="add-milestones" title="Add Milestones" hide-footer>
        <form @submit.prevent="handleAdd">
          <div class="form-group">
            <label for="goal-title">Title</label>
            <input type="text" v-model="milestones.title" id="goal-title" name="title" class="form-control" :class="{ 'is-invalid': submitted && $v.milestones.title.$error }" />
            <div v-if="submitted && !$v.milestones.title.required" class="invalid-feedback">Title is required</div>
          </div>
          <div class="form-group">
            <label for="goal-description">Description</label>
            <textarea rows="3" v-model="milestones.description" id="goal-description" name="description" class="form-control" :class="{ 'is-invalid': submitted && $v.milestones.description.$error }" ></textarea>
            <div v-if="submitted && !$v.milestones.description.required" class="invalid-feedback">Description is required</div>
          </div>
          <div class="form-group">
            <button class="btn btn-primary">Add Milestones</button>
          </div>
        </form>
      </b-modal>
    </div>

    <div class="card-body position-relative" v-show="showMilestones">
      <div v-if="!isDragging" class="isDragging"></div>
      <div class="new-users">
        <draggable
          v-if="milestones_data"
          :list="milestones_data"
          :disabled="!enabled"
          class="list-group"
          ghost-class="ghost"
          :move="checkMove"
          @start="dragging = true"
          @end="checkEnd"
          handle=".handle-drag"
        >
          <div v-for="(item, index) in milestones_data" :key="index" class="d-flex flex-column">
            <div class="media">
              <div class="handle-drag">
                <i class="fa fa-align-justify"></i>
              </div>
              <div class="media-body">
                <h5 class="mb-0 f-w-700" v-b-toggle="'collapseicon'+index">{{item.title}}</h5>
                <p>{{item.description}}</p>
              </div>
              <span class="pull-right">
                <button type="button" class="btn btn-pill btn-light mr-2 btn-icon-center" v-b-tooltip.hover title="Delete" @click="deleteMilestone(item)">
                  <i class="fa fa-trash-o"></i>
                </button>
                <button type="button" class="btn btn-pill btn-light mr-2 btn-icon-center" v-b-tooltip.hover title="Copy" @click="copyMilestone(item)">
                  <i class="fa fa-clone"></i>
                </button>
                <button type="button" class="btn btn-pill btn-light mr-2 btn-icon-center" v-b-tooltip.hover title="Edit" @click="openEditModal(item)">
                  <i class="fa fa-edit"></i>
                </button>
                <button type="button" class="btn btn-pill btn-outline-light collapseicon-btn btn-icon-center" v-b-toggle="'collapseicon'+index">
                  <i class="fa fa-angle-right"></i>
                </button>
              </span>
            </div>
            <b-collapse :id="'collapseicon'+index" role="tabpanel" class="collapseicon-wrapper">
              <tasks :milestoneId="item.uid" v-if="isDragging"/>
            </b-collapse>
          </div>
        </draggable>

        <div v-else>
          <div role="alert" aria-live="polite" aria-atomic="true" class="alert alert alert-primary outline alert-primary">
            <p>There are no Milestones yet</p></div>
        </div>

        <b-modal ref="edit-milestones" title="Edit Milestones" hide-footer>
          <form @submit.prevent="handleEdit">
            <div class="form-group">
              <label for="milestones-edit-title">Title</label>
              <input type="text" v-model="milestonesEdit.title" id="milestones-edit-title" name="title" class="form-control" :class="{ 'is-invalid': submittedEdit && $v.milestonesEdit.title.$error }" />
              <div v-if="submittedEdit && !$v.milestonesEdit.title.required" class="invalid-feedback">Title is required</div>
            </div>
            <div class="form-group">
              <label for="milestones-edit-description">Description</label>
              <textarea rows="3" v-model="milestonesEdit.description" id="milestones-edit-description" name="description" class="form-control" :class="{ 'is-invalid': submittedEdit && $v.milestonesEdit.description.$error }" ></textarea>
              <div v-if="submittedEdit && !$v.milestonesEdit.description.required" class="invalid-feedback">Description is required</div>
            </div>
            <div class="form-group">
              <button class="btn btn-primary">Update</button>
            </div>
          </form>
        </b-modal>
      </div>
    </div>

    <div class="calendar-container" v-show="showCalendar">

      <v-calendar
        class="custom-calendar max-w-full"
        :masks="masks"
        :attributes="attributes"
        :rows="1" :columns="$screens({ default: 1, lg: 2 })"
        disable-page-swipe
        style="width:100%;"
      >
        <div
          slot="day-content"
          v-on="dayEvents"
          @click="dayClick"
          slot-scope="{ day, attributes }"
          class="flex flex-col h-full z-10 overflow-hidden"
          :class="day.year"
        >
          <span
            class="day-label text-sm text-gray-900"
            :class="[day.dateTime === today ? 'today rounded-sm' : '' ]"
          >{{ day.day }}</span>
          <div class="flex-grow overflow-y-scroll overflow-x-auto">
            <p
              v-for="attr in attributes"
              :key="attr.key"
              class="text-xs leading-tight rounded-sm p-1 mt-0 mb-1"
              :class="attr.customData.class"
            >{{ attr.customData.title }}</p>
          </div>
        </div>
      </v-calendar>

      <div class="legenend" v-for="(item, index) in milestones_colors" :key="index" >
        <div :class="`color ${item.color}`"></div>
        <div class="desc">{{item.milestone}}</div>
      </div>
    </div>

  </div>
</template>

<script>
  import { required } from "vuelidate/lib/validators";
  import Tasks from "./tasks";
  import draggable from "vuedraggable";


  export default {
    name: "milestones",
    components: {
      Tasks,
      draggable
    },
    data() {
      const now = new Date();
      const month = now.getMonth();
      const year = now.getFullYear();
      const day = now.getDate();

      return {
        draggingItem: [],
        enabled: true,
        dragging: false,
        isDragging: true,
        milestones_data: [],
        milestones_colors: [],
        maxSequence: 0,
        showCalendar: false,
        showMilestones: true,
        refreshBtn: 'Refresh',
        calendarColors: ['bg-red-600','bg-pink-500','bg-teal-500','bg-indigo-500'],
        milestones: {
          title: "",
          description: "",
          sequence: 0
        },
        milestonesEdit: {
          title: "",
          description: ""
        },
        submittedEdit: false,
        submitted: false,
        renderComponent: true,
        today: new Date(year, month, day) * 1,
        masks: {
          weekdays: "WWW"
        },
        attributes: [],
        dayEvents: {
          click: a => {
            // eslint-disable-next-line no-console
            console.log("dayEvents:", a);
          }
        }
      }
    },
    validations: {
      milestones: {
        title: { required },
        description: { required }
      },
      milestonesEdit: {
        title: { required },
        description: { required }
      },
    },
    props: {
      id: {
        type: [String],
        default: ""
      },
      tracId: {
        type: [String],
        default: ""
      }
    },
    methods: {
      filterObj(arr, searchKey) {
        return arr.filter(function(obj) {
          return Object.keys(obj).some(function(key) {
            return obj[key].includes(searchKey);
          })
        });
      },
      fetchCalendar() {
        this.$store.dispatch("getCalendar", this.tracId).then(() => {
          /* Real Data */
          if (this.$store.state.calendar) {
            for(const [key, value] of Object.entries(this.$store.state.calendar)) {
              //If exists, fetch color
              const result = this.milestones_colors.find( ({ milestone }) => milestone ===  value.customData['milestoneTitle']);
              if(result) {
                value.customData['class'] = result.color;
                value.customData['key'] = key;
              } else {
                //Check if any colors available, else assign red
                if(this.calendarColors.length === 0) {
                  this.calendarColors[0] = 'bg-red-600'
                }
                //Store and assign a new color
                this.milestones_colors.push({
                  milestone: value.customData['milestoneTitle'],
                  color: this.calendarColors[0]
                })
                //Add to main
                value.customData['class'] = this.calendarColors[0];
                //Remove Color from stack
                this.calendarColors.shift();
              }

              value.dates[0] = new Date(value.dates[0]);
              value.dates[1] = new Date(value.dates[0]);
              this.attributes.push(value);
            }
            this.refreshBtn = "Refresh";
          } else {
            this.attributes = [];
            this.refreshBtn = "Refresh";
          }
          console.log(this.milestones_colors);
        });
      },
      reloadCalendar() {
        this.refreshBtn = "Loading...";
        this.attributes = [];
        this.fetchCalendar()

      },
      changeTab(id) {
        if(id=="milestones") {
          this.showCalendar = false;
          this.showMilestones = true;
        } else {
          this.showCalendar = true;
          this.showMilestones = false;
        }
      },
      openEditModal(item) {
        this.milestonesEdit.id = item.uid;
        this.milestonesEdit.goalId = item.goalUID;
        this.milestonesEdit.title = item.title;
        this.milestonesEdit.description = item.description;
        this.milestonesEdit.sequence = item.sequence;
        this.$refs['edit-milestones'].show();
      },
      deleteMilestone(milestones) {
        this.$swal({
          text:'Are you sure you want to do delete "' + milestones.title + '"?',
          showCancelButton: true,
          confirmButtonText: 'Yes',
          confirmButtonColor: '#4466f2',
          cancelButtonText: 'Cancel',
          cancelButtonColor: '#efefef',
          reverseButtons: true
        }).then((val) => {
          if (val.value) {
            this.$store.dispatch('deleteMilestone', milestones).then((val) => {
              if (val.data.statusCode && val.data.statusCode === 200) {
                this.$toasted.show(' Successfully done ', {
                  theme: 'bubble',
                  position: "top-right",
                  type: 'success',
                  duration: 2000
                });
                this.init();
              } else {
                this.$toasted.show(' Please try again ', {
                  theme: 'bubble',
                  position: "top-right",
                  type: 'error',
                  duration: 2000
                });
              }
            }).catch(() => {
              this.$toasted.show(' Please try again ', {
                theme: 'bubble',
                position: "top-right",
                type: 'error',
                duration: 2000
              });
            })
          }
        });
      },
      dayClick(a) {
        // eslint-disable-next-line no-console
        console.log("origin DOM click", a);
      },
      handleEdit() {
        this.submittedEdit = true;

        this.$v.milestonesEdit.$touch();
        if (this.$v.milestonesEdit.$invalid) {
          return;
        }

        this.$store.dispatch('editMilestones', this.milestonesEdit).then(() => {
          this.$toasted.show(' Successfully Changed ', {
            theme: 'bubble',
            position: "top-right",
            type: 'success',
            duration: 2000
          });
          this.$refs['edit-milestones'].hide();
          this.init();
        })
      },
      handleAdd() {
        this.submitted = true;

        this.$v.milestones.$touch();
        if (this.$v.milestones.$invalid) {
          return;
        }

        this.milestones.goalId = this.id;
        this.milestones.sequence = this.maxSequence !== null ? (this.maxSequence + 1) : 0;

        this.$store.dispatch('addMilestones', this.milestones).then(() => {
          this.$toasted.show(' Successfully added ', {
            theme: 'bubble',
            position: "top-right",
            type: 'success',
            duration: 2000
          });
          this.$refs['add-milestones'].hide();
          this.$v.milestones.$reset();
          this.milestones = {
            title: "",
            description: "",
            sequence: 0
          };
          this.init();
        }).catch(() => {
          this.$toasted.show(' Please try again ', {
            theme: 'bubble',
            position: "top-right",
            type: 'error',
            duration: 2000
          });
        })
      },
      init() {
        this.milestones_data = [];
        this.maxSequence = 0;

        this.$store.dispatch("getMilestones", this.id).then(() => {
          if (this.$store.state.milestone) {
            let previousMilestoneId = '';

            for (const [key, value] of Object.entries(this.$store.state.milestone)) {
              if (value.details.sequence > this.maxSequence) {
                this.maxSequence = value.details.sequence;
              }

              value.key = key;
              value.details.previousMilestoneId = previousMilestoneId;

              this.milestones_data.push(value.details)

              previousMilestoneId = value.details.uid;
            }
          }
          else {
            this.maxSequence = null;
            this.milestones_data = null;
          }
        });

        this.fetchCalendar();
      },
      checkMove(e) {
        let newOrderElement = e.draggedContext.element;
        let oldOrderElement = e.relatedContext.element;

        this.draggingItem = {
          one: {data: newOrderElement, sequence: oldOrderElement.sequence},
          two: {data: oldOrderElement, sequence: newOrderElement.sequence}
        };
      },
      async updateSequence(data, sequence) {

        for (const value of Object.entries(this.milestones_data)) {
          if (value[1].uid === data.uid) {
            value[1].sequence = +sequence;
          }
        }

        let payload = {
          id: data.uid,
          goalId: data.goalUID,
          title: data.title,
          description: data.description,
          sequence: data.sequence
        };
        await this.$store.dispatch('editMilestones', payload);
      },
      async checkEnd() {
        this.dragging = false;
        this.isDragging = false;

        for await (const [index, value] of Object.entries(this.milestones_data)) {
          this.updateSequence(value, index)
        }

        this.draggingItem = [];
        this.isDragging = true
      },
      copyMilestone(item) {
        this.$swal({
          text:'Are you sure you want to do copy "' + item.title + '"?',
          showCancelButton: true,
          confirmButtonText: 'Yes',
          confirmButtonColor: '#4466f2',
          cancelButtonText: 'Cancel',
          cancelButtonColor: '#efefef',
          reverseButtons: true
        }).then((val) => {
          if (val.value) {
            this.$store.dispatch('copyMilestone', item).then(() => {
              this.$toasted.show(' Successfully done ', {
                theme: 'bubble',
                position: "top-right",
                type: 'success',
                duration: 2000
              });
              this.init();
            }).catch(() => {
              this.$toasted.show(' Please try again ', {
                theme: 'bubble',
                position: "top-right",
                type: 'error',
                duration: 2000
              });
            })
          }
        })
      }
    },
    created() {
      this.init();
    }
  }
</script>

<style scoped lang="scss">

  .flex-col {
    flex-direction: column;
  }

  .flex {
    display: flex;
  }
  .flex-grow {
    flex-grow: 1;
  }
  .h-full {
    height: 100%;
  }
  .bg-red-600 {
    background-color: #e53e3e;
    color:#fff;
  }
  .today {
    background-color: #d2e1ec;
    color:#fff;
  }
  .bg-teal-500 {
    background-color: #38b2ac;
    color:#fff;
  }
  .bg-pink-500 {
    background-color: #ed64a6;
    color:#fff;
  }
  .bg-indigo-500 {
    background-color: #667eea;
    color:#fff;
  }
  .overflow-y-scroll {
    overflow-y: scroll;
  }
  .overflow-x-auto {
    overflow-x: auto;
  }
  .z-10 {
    z-index: 10;
  }
  .overflow-hidden {
    overflow: hidden;
  }
  .text-gray-900 {
    color: #1a202c;
  }
  .vc-h-full {
    height: 100%;
  }
  .custom-calendar.vc-container {
    --day-border: 1px solid #b8c2cc;
    --day-border-highlight: 1px solid #b8c2cc;
    --day-width: 90px;
    --day-height: 90px;
    --weekday-bg: #f8fafc;
    --weekday-border: 1px solid #eaeaea;
    border-radius: 0;
    width: auto;
  }
  .custom-calendar.vc-container .vc-weeks {
    padding: 0;
    height: 80vh;
    grid-template-rows: 33px repeat(6, 1fr);
  }
  .custom-calendar.vc-container .vc-header {
    background-color: #f1f5f8;
    padding: 10px 0;
  }
  .custom-calendar.vc-container .vc-weekday {
    background-color: var(--weekday-bg);
    border-bottom: var(--weekday-border);
    border-top: var(--weekday-border);
    padding: 5px 0;
  }
  .vc-border {
    border-width: 1px;
  }
  .custom-calendar.vc-container .vc-day:not(.on-right) {
    border-right: var(--day-border);
  }
  .custom-calendar.vc-container .vc-day:not(.on-bottom) {
    border-bottom: var(--day-border);
  }
  .custom-calendar.vc-container .vc-day.weekday-1,
  .custom-calendar.vc-container .vc-day.weekday-7 {
    background-color: #eff8ff;
  }

  .custom-calendar.vc-container .vc-day {
    padding: 0 5px 3px;
    text-align: left;
    /*min-height: var(--day-height);*/
    min-width: var(--day-width);
    background-color: #fff;
  }
  .vc-day {
    position: relative;
    min-height: var(--day-min-height);
    width: 100%;
    height: 100%;
    z-index: 1;
  }
  .text-center {
    text-align: center;
  }
  .section {
  }
  .max-w-full {
    max-width: 100%;
  }
  .bg-blue-500 {
    background-color: #4299e1;
  }

  .text-xs {
    font-size: 0.75rem;
  }
  .text-white {
    color: #fff;
  }
  .p-1 {
    padding: 0.25rem;
  }
  .mb-1 {
    margin-bottom: 0.25rem;
  }
  .mt-0 {
    margin-top: 0;
  }
  .leading-tight {
    line-height: 1.25;
  }
  .rounded-sm {
    border-radius: 0.125rem;
  }
  ::-webkit-scrollbar {
    width: 0px;
  }
  ::-webkit-scrollbar-track {
    display: none;
  }

  .calendar-container {
    padding:30px;
  }

  /* Custom */
  .custom-calendar.vc-container .vc-day:not(.on-bottom) {
    border-bottom: 1px solid #b8c2cc !important;
  }

  .custom-calendar.vc-container .vc-day:not(.on-right) {
      border-right: var(--day-border);
  }
  .custom-calendar.vc-container .vc-day {
      padding: 0 5px 3px;
      text-align: left;
      /* min-height: var(--day-height); */
      min-width: var(--day-width);
      background-color: #fff;
  }

  .custom-calendar.vc-container .vc-day {
      padding: 0 5px 3px;
      text-align: left;
      min-height: 90px;
      min-width: 90px;
      background-color: #fff;
  }

  .vc-container .vc-day {
      width: 90px !important;
      height: 90px !important;
  }

  .ghost {
    overflow: hidden;
    position: relative;

    &:after {
      content: "";
      position: absolute;
      top: 0;
      left: 0;
      bottom: 0;
      right: 0;
      z-index: 1;
      background-color: #afe4ff;
    }
  }
  .milestones-card {
    .card-header {
      display: flex;
      align-items: center;

      .d-flex {
        margin-left:auto;
      }

      h5 {
        cursor:pointer;
      }

      .btn-calendar {
        border-left:1px solid grey;
        margin-left:20px;
        padding-left:20px;
      }
    }

    .collapseicon-wrapper {
      background: rgb(246, 247, 251);
      padding: 20px 0;
      margin-bottom: 30px;
    }

    .btn-icon-center {
      padding: 0.375rem 14px;

      i {
        margin: 0 auto;
      }
    }

    .collapseicon-btn {
      background-color: #4466f2;
      border-color: #4466f2;
      color: #fff;
      i {
        transition: 0.5s;
        transform: rotate(90deg);
      }

      &.collapsed {
        border-color: #f6f7fb;
        background-color: transparent;
        color: #2a3142;
        i {
          transform: rotate(0deg);
        }
      }
    }
  }

  .isDragging {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 9;
    background-color: #ffffff75;
  }

  .handle-drag {
    width: 40px;
    height: 100%;
    margin: auto 0;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: move;
    margin-right: 15px;

    i {
      font-size: 20px;
    }
  }

  .legenend {
    margin-top:20px;
    display:flex;
    font-weight:600;

    .color {
      height:20px;
      width:20px;
      border-radius:3px;
      margin-right:10px;
      border:1px solid rgb(185, 185, 185);
    }
  }

  @media (max-width: 768px) {
    .new-users .media span {
      display: flex;
      flex-direction: column;
      margin-top: 0;
      .collapseicon-btn {
        width: 44px;
      }
      button {
        border-radius: 0;
        margin-right: 0 !important;
      }
    }
  }
</style>
